import { remove } from "lodash";

export default {
  add: "Add",
  addNorm: "+Add Norm (1.06 - 1.09)",
  addSimulationSoftware: "+Add Simulation Software",
  apply: "Apply",
  approve: "Approve",
  // assign: "Assign",
  // attributeSets: "Attribute Sets",
  back: "Back",
  cancel: "Cancel",
  // change: "Change",
  close: "Close",
  collapse: "Collapse all",
  confirm: "Confirm",
  // continue: "Continue",
  create: "Create",
  // createdBy: "created by",
  databaseAccess: "Units & Certificates",
  // databaseText: "Access the Public Register instantly to view publicly available module certificates",
  delete: "Delete",
  deny: "Deny",
  discard: "Discard",
  // done: "Done",
  // download: "Download",
  // edit: "Edit",
  editName: "Edit Name",
  changePassword: "Change Password",
  discardErrorReportButtonLabel: "Discard Error Report",
  errorReportButtonLabel: "Report Error",
  expand: "Expand all",
  // filters: "Filters",
  goBack: "Go Back",
  // hide: "hide related assets",
  homePage: "Home Page",
  logIn: "Log In",
  logOut: "Log Out",
  // loginText: "To access all features, simply log in with your username and password",
  new: "New",
  // newLog: " New Log",
  // next: "Next",
  no: "No",
  continue: "Continue",
  // OK: "OK",
  refreshTable: "Refresh Table",
  // registration: "Registration",
  // registrationText: "Don`t have an account yet? Click here to create one.",
  reload: "Reload",
  remove: "Remove",
  // replace: "replace",
  // reserve: "Reserve",
  reset: "Reset",
  resetAllFilters: "Reset all filters",
  revoke: "Revoke",
  // run: "Run",
  save: "Save",
  saveChanges: "Save Changes",
  // send: "Send",
  sendInvite: "Send Invite",
  // settings: "Settings",
  // show: "Show related assets",
  showFullText: "full text",
  sort: "Sorting",
  submit: "Submit",
  // unassign: "unassign",
  undoChanges: "Undo Changes",
  // unselect: "Unselect",
  uploadGridConnectionValues: "Upload List of Grid Connection Values",
  yes: "Yes",
  linkToHome: "Link to Home",
  linkTo: "Link to",
  subscribe: "Subscribe",
  unsubscribe: "Unsubscribe",
  showRoleDescription: "show role description",
};
